import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { GoogleButton } from '../components/shared/GoogleButton';
import { Footer } from '../components/shared/Footer';

export const Login = () => {
  const navigate = useNavigate();
  const { login, isLoading, error } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await login({ email, password });
      navigate('/dashboard');
    } catch {
      /* l'erreur est déjà affichée via useAuth().error */
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-semibold text-neutral-900">Falko</h1>
          <p className="mt-2 text-sm text-neutral-500">Connexion à ton espace</p>
        </div>
        <div className="bg-white rounded-2xl shadow-sm border border-neutral-200 p-6 space-y-4">
          <GoogleButton />
          <div className="flex items-center gap-3 text-xs text-neutral-400">
            <span className="flex-1 border-t border-neutral-200" />
            <span>ou avec ton email</span>
            <span className="flex-1 border-t border-neutral-200" />
          </div>
          <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-neutral-700 mb-1">
              Adresse email
            </label>
            <input
              id="email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent"
              placeholder="toi@exemple.com"
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-neutral-700 mb-1">
              Mot de passe
            </label>
            <input
              id="password"
              type="password"
              required
              minLength={8}
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <div className="rounded-lg bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700">{error}</div>
          )}
          <button
            type="submit"
            disabled={isLoading}
            className="w-full rounded-lg bg-violet-600 text-white py-2 text-sm font-medium hover:bg-violet-700 disabled:opacity-50 disabled:cursor-not-allowed transition"
          >
            {isLoading ? 'Connexion…' : 'Se connecter'}
          </button>
          <p className="text-center text-sm">
            <Link to="/forgot-password" className="text-neutral-500 hover:text-neutral-700">
              Mot de passe oublié ?
            </Link>
          </p>
          </form>
        </div>
        <p className="mt-6 text-center text-sm text-neutral-600">
          Pas encore de compte ?{' '}
          <Link to="/register" className="text-violet-600 hover:text-violet-700 font-medium">
            Créer un compte
          </Link>
        </p>
        <Footer />
      </div>
    </div>
  );
};
